module.exports = __webpack_public_path__ + "static/media/robert-beard-danielle-roossien-at-workbench.9096958f.webp";